import { Component } from '@angular/core';

import { TranslatePipe } from '@camelot/translation';

import { CamDynamicTranslationService } from '../../../../../services/dynamic-translation.service';
import { dynamicTranslationPrefix } from '../../../../../services/dynamic-translation.service';
import { AbstractCellComponent } from '../../abstract';

@Component({
  host: { 'data-cid': 'grid-dynamic-key-cell' },
  imports: [TranslatePipe],
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  // translate renvoie la clé quand la traduction manque : on laisse alors la cellule vide
  template: `@if (this.value) {
    @let key = this.dynamicTranslationPrefix(this.value);
    @let translated = key | translate;
    @if (translated !== key) {
      {{ translated }}
    }
  }`,
})
export class GridDynamicKeyCellComponent extends AbstractCellComponent<any, string> {
  readonly dynamicTranslationPrefix = dynamicTranslationPrefix;

  constructor() {
    super();
    CamDynamicTranslationService.getInstance();
  }
}
